import React from "react"

const Footer = () => (
  <div className="site-footer">
    <h4 className="text-center">Blog Dasz Wiarę?</h4>
    <p className="text-center">Jesteśmy na:</p>
    <div className="footer-social-links">
      <ul className="social-links-list">
        <li>
          <a
            href="https://www.wykop.pl/tag/daszwiare/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Wykopie
          </a>
        </li>
      </ul>
    </div>
  </div>
)

export default Footer
